import { Component } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ReportGetter } from '../../directives/ReportGetter';
import { ReportBuilderService } from '../../services/report-builder.service';
import { Router } from '@angular/router';
import { NavigationService } from '../../../../shared/services/navigation.service';
import { GuardService } from '../../../../shared/services/guard.service';
import { ModuleService } from '../../../../shared/services/module.service';
import { IS_PRODUCT_SAFETY_PROJECT, IS_TRS_PROJECT } from '../../../../../current-project';
import { TinyHelper } from '../../../../shared/helpers/tiny.helper';

@Component({
    selector: 'app-report-signature-upload',
    templateUrl: './report-signature-upload.component.html',
    styleUrls: ['./report-signature-upload.component.scss'],
    standalone: false
})
export class ReportSignatureUploadComponent extends ReportGetter {
    IS_TRS_PROJECT = IS_TRS_PROJECT;
    IS_PRODUCT_SAFETY_PROJECT = IS_PRODUCT_SAFETY_PROJECT;

    get files(): File[] {
        return this.report.signDocuments as File[];
    }

    constructor(
        public dialogRef: MatDialogRef<ReportSignatureUploadComponent>,
        builder: ReportBuilderService,
        dialog: MatDialog,
        router: Router,
        navigation: NavigationService,
        guard: GuardService,
        moduleService: ModuleService
    ) {
        super(builder, dialog, router, navigation, guard, moduleService);
        this.report.signDocuments = this.report.signDocuments || [];
    }

    uploadSignature(): void {
        this.dialogRef.close(true);
    }

    protected setSignedDocuments(documents: FileList): void {
        const pdfDocuments = Array.from(documents).filter(file => file.type === 'application/pdf');
        this.report.signDocuments = pdfDocuments.length > 0 ? [pdfDocuments[0]] : [];
    }

    protected removeSignedDocument(): void {
        this.report.signDocuments = [];
    }

    protected getFile(): File {
        return (this.report.signDocuments as [File])[0];
    }

    protected getFileLastModifiedDate(file: File): Date {
        return new Date(file.lastModified);
    }

    protected getFileSize(file: File): string {
        return TinyHelper.convertBytesToMB(file.size);
    }
}
